// Whether the page being rendered was reached with the browser's back/forward buttons — listings
// restore the shopper's scroll position then, but start at the top on a regular link click.
let lastTraversalAt = 0;
let installed = false;

/** Called once from the root layout (GlobalRouteProgress), before any listing can mount. */
export function installHistoryTraversalTracking(): void {
    if (installed || typeof window === 'undefined') return;
    installed = true;
    window.addEventListener('popstate', () => { lastTraversalAt = Date.now(); });
}

export function arrivedViaHistoryTraversal(): boolean {
    if (typeof window === 'undefined') return false;
    if (Date.now() - lastTraversalAt < 5000) return true;
    // A full reload on back/forward (no bfcache): the document itself says so.
    const [navigation] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    return navigation?.type === 'back_forward' && performance.now() < 10000;
}
